import MessagingHome from 'src/modules/concession/messaging/home/MessagingHome.vue'

import { GlobalController } from 'src/shared/global/GlobalController'

const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}

export const routes = [
  {
    path: 'messaging',
    name: 'MessagingHome',
    component: MessagingHome,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
